import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_ARE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
} from "constants/FormatDataContanst";

export const getRegistryStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status.init"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      //"Chờ phát hành"
      text: t("auth_status.progressing"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_REJECT]: {
      //"Từ chối phát hành",
      text: t("auth_status.reject"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_APPROVE]: {
      //"Đã phát hành",
      text: t("auth_status.approve"),
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_RR]: {
      //"Từ chối tiếp nhận đăng ký",
      text: t("auth_status.rr"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_RRE]: {
      //"Từ chối tiếp nhận thay đổi"
      text: t("auth_status.rre"),
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      // Đã tiếp nhận đăng ký
      text: t("auth_status.ar"),
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_ARE]: {
      // Đã tiếp nhận thay đổi
      text: t("auth_status.are"),
      badgeColor: "badge-soft-info",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};
